
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import moment from "moment";
import Logo from "../../../src/vendor/Whiteswan-Security-logo.png"

export interface AlertLog {
    tenantName?: string;
    _time?: string;
    computerUserEmail?: string;
    computerName?: string;
    resourceType?: string;
    resourceName?: string;
    message?: string;
    alertJson?: string;
}

export async function downloadAlertReportPDF(
    logs: AlertLog[],
    dateRange: [string | null, string | null],
    searchTerm: string,
    includeAlertJson: boolean
) {



    const pdf = new jsPDF();

    const pageWidth = pdf.internal.pageSize.getWidth();

    const [startDateRaw, endDateRaw] = dateRange;
    const startDate = startDateRaw ? moment(startDateRaw).format("DD/MM/YYYY") : "-";
    const endDate = endDateRaw ? moment(endDateRaw).format("DD/MM/YYYY") : "-";

    const imgX = (pageWidth - 100) / 2;

    pdf.setFillColor(35, 48, 68);
    pdf.rect(0, 0, pageWidth, 40, "F");
    pdf.addImage(Logo, "PNG", imgX, 5, 100, 30);

    const tenantNames = [...new Set(logs.map((log) => log.tenantName))];

    tenantNames.forEach((tenantName, index) => {
        const startY = index === 0 ? 50 : 20;
        const tenantLogs = logs.filter((log) => log.tenantName === tenantName);

        pdf.text(`Tenant Name: ${tenantName || "-"}`, 10, startY + 10);
        pdf.text(`Start Date: ${startDate}`, 10, startY + 20);
        pdf.text(`End Date: ${endDate}`, 10, startY + 30);
        pdf.text(`Search Term: "${searchTerm?.trim() || "-"}"`, 10, startY + 40);

        const tableHead = [
            [
                "Sl No",
                "Time",
                "User",
                "Computer Name",
                "Type",
                "Resource Name",
                "Action",
            ],
        ];
        // Build table body with optional JSON row after each alert
        const tableBody: any[][] = [];
        tenantLogs.forEach((log, i) => {
            // Main alert row
            tableBody.push([
                i + 1,
                log._time ? moment(log._time).format("DD.MM.YYYY HH:mm") : "-",
                log.computerUserEmail || "-",
                log.computerName || "-",
                log.resourceType || "-",
                log.resourceName || "-",
                log.message || "-",
            ]);
            // JSON row (spanning all columns) - single cell, bold title, no extra borders
            if (includeAlertJson && log.alertJson) {
                let parsed: any = log.alertJson;
                if (typeof log.alertJson === "string") {
                    try {
                        parsed = JSON.parse(log.alertJson);
                    } catch {
                        parsed = log.alertJson;
                    }
                }
                const isEmpty =
                    parsed == null ||
                    (typeof parsed === "object" && Object.keys(parsed).length === 0) ||
                    (typeof parsed === "string" && parsed.trim() === "");
                let jsonString: string;
                if (isEmpty) {
                    jsonString = "No data available.";
                } else if (typeof parsed === "object") {
                    jsonString = JSON.stringify(parsed);
                } else {
                    jsonString = String(parsed);
                }
                // Place 'Alert JSON:' on its own line, then the JSON string
                const combinedContent = `Alert JSON:\n${jsonString}`;
                tableBody.push([
                    {
                        content: combinedContent,
                        colSpan: 7,
                        styles: {
                            fontSize: 10,
                            textColor: [50, 50, 50],
                            cellPadding: { top: 2, right: 18, bottom: 6, left: 22 },
                            font: 'courier',
                            fillColor: [245, 246, 248],
                            halign: 'left',
                            valign: 'top',
                            borderWidth: { left: 4, top: 0, right: 0, bottom: 0 },
                            borderColor: { left: [80, 120, 200], top: [245, 246, 248], right: [245, 246, 248], bottom: [245, 246, 248] },
                        },
                        didDrawCell: function (data: any) {
                            const raw = data.cell.raw;
                            if (
                                raw &&
                                typeof raw.content === "string" &&
                                raw.content.startsWith("Alert JSON:")
                            ) {
                                const { x, y, width } = data.cell;
                                // Draw bold title manually
                                pdf.setFont("helvetica", "bold");
                                pdf.setFontSize(12);
                                pdf.setTextColor(35, 48, 68);
                                pdf.text("Alert JSON:", x + 6, y + 10, { maxWidth: width - 12 });
                                // Draw JSON content on the next line, autowrap
                                pdf.setFont("courier", "normal");
                                pdf.setFontSize(10);
                                pdf.setTextColor(50, 50, 50);
                                const jsonText = raw.content.replace("Alert JSON:\n", "");
                                const split = pdf.splitTextToSize(jsonText, width - 12);
                                pdf.text(split, x + 6, y + 16);
                            }
                        }
                    }
                ]);
            }
        });
        autoTable(pdf, {
            startY: startY + 50,
            headStyles: { fillColor: [35, 48, 68], halign: "center" },
            head: tableHead,
            body: tableBody,
            bodyStyles: { halign: "center" },
            margin: { top: 5, right: 0, bottom: 0, left: 0 },
            columnStyles: {
                0: { cellWidth: 10 },
                1: { cellWidth: 25 },
                2: { cellWidth: 30 },
                3: { cellWidth: 30 },
                4: { cellWidth: 25 },
                5: { cellWidth: 30 },
                6: { minCellWidth: 50 },
            },
            // All JSON row styling is set inline above for reliability
        });
        if (index < tenantNames.length - 1) {
            pdf.addPage();
        }
    });

    pdf.save("Recent_Alerts_Report.pdf");
}
